import './preloader.css'

const Preload=()=>{
    return (
        <div id="preloader">
            <div id="loader"></div>
        </div>
    )
} 

export default Preload